import { PackageProviderName } from 'data/ppoints/constants';
import { array, nativeEnum, object, string } from 'zod';

/**
 * @param isWithinPlanLimit Whether the selection fits the current plan's carrier limit — it lives in
 * hooks, so the step builds its schema with it instead of the schema reading it on its own.
 */
export const createServiceProviderStepSchema = (
    isWithinPlanLimit: (selectedProviders: PackageProviderName[]) => boolean
) =>
    object({
        // The country the selection below belongs to. Not validated on its own: it is resolved by the
        // selector, never typed, and a missing selection is already reported by `selectedProviders`.
        countryCode: string(),
        selectedProviders: array(nativeEnum(PackageProviderName))
            .min(1, {
                message: 'WIZARD.SERVICE_PROVIDER_STEP.PROVIDERS_REQUIRED',
            })
            .refine(isWithinPlanLimit, {
                message: 'WIZARD.SERVICE_PROVIDER_STEP.PLAN_LIMIT_BANNER.ERROR',
            }),
    });

/** Shape-only schema, without the plan limit rule; the step itself uses `createServiceProviderStepSchema` */
const serviceProviderStepSchema = createServiceProviderStepSchema(() => true);

export default serviceProviderStepSchema;
